<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead
        :title="'Squids'"
        :buttons="[
          {
            title: 'Add Squid',
            icon: 'fa fa-plus',
            emit: 'add',
          },
        ]"
        @add="addShow = true"
      ></cardHead>
      <dataTable
        :name="'TechnicalsSquids'"
        ref="agGrid"
        :data="data"
        @update="updateShow = $event"
        @remove="remove"
      ></dataTable>
      <upsert
        v-if="addShow || (updateShow != null && data != null)"
        :setModel="updateShow"
        @add="$refs.agGrid.addRow([$event])"
        @update="$refs.agGrid.changeRow('Id', $event)"
        :operators="data"
        @close="
          addShow = false;
          updateShow = null;
        "
      ></upsert>
    </div>
  </div>
</template>

<script>
import upsert from "./upsert";
export default {
  name: "Squids",
  components: { upsert },
  data() {
    return {
      data: null,
      addShow: false,
      updateShow: null,
    };
  },
  created() {
    this.$appAxiosAdmin.get(`Squids`).then((response) => {
      this.data = response.data;
    });
  },
  methods: {
    remove(item) {
      this.$swal({
        icon: "question",
        title: "Warning!",
        text:
          "Are you sure you want to delete the squid platform named " +
          item.Platform +
          "?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .delete(`Squids/` + item.Id)
            .then(() => {
              this.$refs.agGrid.removeRow([item]);
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The squid has been successfully deleted.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>
